import { render, staticRenderFns } from "./QuestionsNew.vue?vue&type=template&id=27eb6886"
import script from "./QuestionsNew.vue?vue&type=script&lang=js"
export * from "./QuestionsNew.vue?vue&type=script&lang=js"
import style0 from "./QuestionsNew.vue?vue&type=style&index=0&id=27eb6886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports